import { createAction, props } from '@ngrx/store';
import { ServicingCommonState } from './servicing-common.state';

/** StateDetailsActions */
const ACTION_SET = '[ServicingCommon] set';
const ACTION_UPDATE = '[ServicingCommon] update';
const ACTION_RESET = '[ServicingCommon] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setServicingCommon = createAction(ACTION_SET, props<ServicingCommonState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateServicingCommon = createAction(ACTION_UPDATE, props<Partial<ServicingCommonState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetServicingCommon = createAction(ACTION_RESET);
